import { SafePromise } from '@benzinga/safe-await';

import { RestfulClient } from '@benzinga/session';
import { CommentCountResponse } from '../entities';
import { Session } from '@benzinga/session';
import { ArticleEnvironment } from '../environment';

export class CommentsRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ArticleEnvironment).commentsUrl, session, { 'x-device-key': true });
  }

  getCommentCount = (id: number): SafePromise<CommentCountResponse> => {
    if (!Number.isInteger(id) || id <= 0) {
      return Promise.resolve({ ok: { data: { count: 0, id: 0, url: '' } } });
    }
    const url = this.URL('api/comment-count', { id });
    const key = process.env.COMMENT_COUNT_API_KEY;
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
      ...(key ? { headers: { 'x-api-key': key } } : {}),
    });
  };
}
